import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';

/**
 * Landing route for MSAL's redirect flow (`redirectUri` in `environment.*.ts`).
 * Its only job: let MSAL finish processing the auth response, then send the user
 * to the default route. `MsalGuard`/the router take care of the rest (re-activating
 * whatever route was originally protected).
 */
@Component({
	selector: 'app-auth-callback',
	standalone: true,
	template: ''
})
export class AuthCallbackComponent implements OnInit, OnDestroy {
	private readonly destroy$ = new Subject<void>();

	constructor(
		private msalService: MsalService,
		private router: Router
	) {}

	ngOnInit(): void {
		this.msalService
			.handleRedirectObservable()
			.pipe(take(1), takeUntil(this.destroy$))
			.subscribe({
				next: () => this.router.navigate(['/']),
				error: (error) => {
					console.error('MSAL redirect handling failed', error);
					this.router.navigate(['/']);
				}
			});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}

